/**
 * Prevents Angular change detection from
 * running with certain Web Component callbacks
 */
(window as any).__Zone_disable_customElements = true;
(window as any).__zone_symbol__BLACK_LISTED_EVENTS = ['scroll', 'mousewheel', 'pointermove', 'mousemove'];